export interface Newspaper {
  id: string;
  name: string;
  description?: string;
  scope_type: 'school' | 'classroom' | 'group';
  school?: { id: string; name: string };
  classrooms: { id: string; name: string }[];
  teacher: { id: string; name: string; surname: string };
  editions_count: number;
  students_count: number;
  submitted_stories_count: number;
  created_at: string;
  updated_at: string;
}

export interface Edition {
  id: string;
  newspaper_id: string;
  newspaper_name?: string;
  name: string;
  description?: string;
  publish_date?: string;
  status: 'draft' | 'open' | 'published';
  created_at: string;
  updated_at: string;
}

export interface Story {
  id: string;
  edition_id: string;
  student: { id: string; name: string; surname: string };
  template_type: StoryTemplate;
  title?: string;
  status: 'draft' | 'submitted' | 'published';
  proposed_by_student: boolean;
  teacher_approved: boolean | null;
  document_id?: string;
  created_at: string;
  updated_at: string;
}

export type StoryTemplate =
  | 'news_story'
  | 'feature_story'
  | 'profile_interview'
  | 'book_review'
  | 'movie_review'
  | 'video_game_review'
  | 'restaurant_review'
  | 'recipe'
  | 'opinion'
  | 'photo_essay';

export const STORY_TEMPLATE_LABELS: Record<StoryTemplate, string> = {
  news_story: 'News Story',
  feature_story: 'Feature Story',
  profile_interview: 'Profile / Interview',
  book_review: 'Book Review',
  movie_review: 'Movie Review',
  video_game_review: 'Video Game Review',
  restaurant_review: 'Restaurant Review',
  recipe: 'Recipe',
  opinion: 'Opinion Piece',
  photo_essay: 'Photo Essay',
};
